import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { GkComponentsModule, GkMapModule } from "@gk/gk-modules";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared/shared.module";
import { createTranslateLoader } from "../address-number-request-portal/address-number-request-portal.module";
import { HouseholdSewageTreatmentNotificationRoutingModule } from "./household-sewage-treatment-notification-routing.module";
import { HouseholdSewageTreatmentNotificationComponent } from "./household-sewage-treatment-notification.component";
import { HSTNNewRequestComponent } from "./new-request/new-request.component";
import { HSTNNewRequestFormService } from "./services/new-request-form/new-request-form.service";

@NgModule({
  declarations: [
    HouseholdSewageTreatmentNotificationComponent,
    HSTNNewRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    HouseholdSewageTreatmentNotificationRoutingModule,
    MatCheckboxModule,
  ],
  providers: [HSTNNewRequestFormService],
})
export class HouseholdSewageTreatmentNotificationModule {}
